import { useMutation, MutationHookOptions } from '@apollo/client';

import { CREATE_PROVISONAL_PAYMENT_GROUP_LOG } from '@affiliates/queries';
import { CreateProvisionalPaymentGroupLogVariables, CreateProvisionalPaymentGroupLog } from '@affiliates/queries/types/CreateProvisionalPaymentGroupLog';

type TOptions = MutationHookOptions<CreateProvisionalPaymentGroupLog, CreateProvisionalPaymentGroupLogVariables>;

export const useCreateProvisionalPaymentGroupMutation = (options: TOptions = {}) => useMutation<CreateProvisionalPaymentGroupLog, CreateProvisionalPaymentGroupLogVariables>(CREATE_PROVISONAL_PAYMENT_GROUP_LOG, options);
